<div class="signup-group-wrapper" *ngIf="combinedData$ | async as combinedData">
  <!-- Enhanced Header Section -->
  <div class="template-header">
    <div class="header-content">
      <h1 class="template-title">Signup Groups</h1>
      <p class="template-description">
        <code>Signup Groups</code> let you sign up a preset of users directly on event creation.
        <a href="https://docs.raidorganizer.org/signup-groups/" target="_blank" class="docs-link">Read more about them here</a>.
      </p>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="row g-4">
    <!-- Settings Column -->
    <div class="col-12 col-xxl settings-column">
      <div class="section-header">
        <h2 class="section-title">Settings</h2>
        <mat-icon class="section-icon">settings</mat-icon>
      </div>
      <app-signup-group-builder 
        [serverCustomEmojis]="combinedData.customEmojis" 
        [signupGroup]="combinedData.signupGroupInfo">
      </app-signup-group-builder>
    </div>

    <!-- Divider -->
    <div class="col-auto d-none d-xxl-flex align-items-stretch px-0">
      <div class="content-divider"></div>
    </div>

    <!-- Preview Column -->
    <div class="col-12 col-xxl-auto preview-column">
      <div class="section-header">
        <h2 class="section-title">Preview</h2>
        <mat-icon class="section-icon">visibility</mat-icon>
      </div>
      <div class="preview-container">
        <app-embed-preview></app-embed-preview>
      </div>
    </div>
  </div>
</div>
